import React from "react";
import hearderbg from "../Assest/new_logo_withshreebalaji.png";

export default function UserPolicies() {
  return (
    <div className="text-gray-800 overflow-hidden">

      {/* HERO */}
      <section
        className="relative py-28 bg-cover bg-center"
        style={{ backgroundImage: `url(${hearderbg})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#2C3E5C]/70 via-[#1F2A44]/60 to-[#000]/50"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            User Data Policies
          </h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto text-white/90">
            Data & Deletion Policy
          </p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-5xl mx-auto px-6 space-y-10 text-gray-700 leading-relaxed">

          {/* INTRO */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">
              Data & Deletion Policy
            </h2>
            <p>
              We are committed to safeguarding your personal and financial information
              in accordance with the guidelines issued by the Reserve Bank of India (RBI).
            </p>
          </div>

          {/* DATA STORAGE */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">
              1. Data Storage
            </h2>
            <p>
              All user data, including personal details and transaction-related information,
              is securely stored and processed in compliance with applicable RBI regulations
              and industry security standards.
            </p>
          </div>

          {/* DATA DELETION */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">
              2. User Data Deletion Request
            </h2>
            <ul className="list-disc list-inside space-y-2">
              <li>Your personal data will be reviewed and processed for deletion.</li>
              <li>The deletion process will be completed within 3 business days from the date of request.</li>
            </ul>
          </div>

          {/* TRANSACTION DATA */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">
              3. Transaction Data Retention
            </h2>
            <ul className="list-disc list-inside space-y-2">
              <li>Certain transaction-related data cannot be deleted upon request.</li>
              <li>
                This is due to mandatory regulatory requirements set by RBI, which require
                financial institutions to retain transaction records for auditing,
                compliance, and legal purposes.
              </li>
            </ul>
          </div>

          {/* REQUEST */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">
              4. How to Request Data Deletion
            </h2>
            <p>To request deletion of your personal data, please contact us through:</p>
            <ul className="list-disc list-inside mt-3 space-y-2">
              <li>In-app support</li>
              <li>Email: info@bingopays.in</li>
            </ul>
          </div>

          {/* NOTE */}
          <div className="bg-blue-50 border border-blue-200 rounded-xl p-5">
            <p className="text-blue-800 font-semibold mb-2">Note:</p>
            <p>
              While we ensure deletion of eligible personal data, we strictly adhere to
              RBI regulations regarding data retention and compliance.
            </p>
          </div>

        </div>
      </section>
    </div>
  );
}